window.initVideoSoundToggle = (section, videoSelector, { stopPropagation = false } = {}) => {
  const soundButton = section.querySelector('[data-video-sound]')
  const soundLabel = section.querySelector('[data-video-sound-label]')
  const soundOnIcon = section.querySelector('[data-video-sound-icon="on"]')
  const soundOffIcon = section.querySelector('[data-video-sound-icon="off"]')
  const videos = section.querySelectorAll(videoSelector)

  if (!soundButton || !videos.length) return

  const visibleVideos = () => [...videos].filter((video) => video.getClientRects().length > 0)

  soundButton.addEventListener('click', (event) => {
    if (stopPropagation) event.stopPropagation()

    const activeVideo = visibleVideos()[0] || videos[0]
    const nextMuted = !activeVideo.muted

    videos.forEach((video) => {
      if (video === activeVideo) {
        video.muted = nextMuted
        if (!nextMuted) {
          video.play()?.catch(() => {})
        }
      } else {
        video.muted = true
      }
    })

    if (soundLabel) {
      soundLabel.textContent = nextMuted ? soundButton.dataset.soundOn : soundButton.dataset.soundOff
    }

    if (soundOnIcon && soundOffIcon) {
      soundOnIcon.classList.toggle('hidden', !nextMuted)
      soundOffIcon.classList.toggle('hidden', nextMuted)
    }
  })
}
